import React from 'react';
import { LiteTable } from '@roamingaudit/react-lite-table';
import { Button } from 'react-bootstrap';
import { faCode, faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import classes from './Ir21InboxTable.module.css';

const Ir21InboxTable = props => {
  const actions = row => {
    return [
      <Button
        variant="primary"
        className={ classes.actionButton }
        size="sm"
        target="_blank"
        href={ `/info/ir21/xml/${ row.hash }/${ row.document_name }` }>
        <FontAwesomeIcon icon={ faCode }/>
      </Button>,
      <Button
        variant="primary"
        className={ classes.actionButton }
        size="sm"
        target="_blank"
        href={ `/info/ir21/pdf/${ row.hash }/${ row.document_name }` }>
        <FontAwesomeIcon icon={ faFilePdf }/>
      </Button>
    ];
  }

  return <LiteTable
    initialSorting={ {
      column: 'publish_date',
      reversed: true
    } }
    columnsMap={ {
      'document_name': 'Document Name', 'document_type': 'Document Type', 'publish_date': 'Publish Date', 'tadig': 'Tadig'
    } }
    withFiltering
    withSorting
    rows={ props.rows }
    actions={ actions }/>;
};

export default Ir21InboxTable;
